import { isdisabled } from "@/filters/index.js";

export class Emccompute {
  //已选所有的店铺数量
  static queryAllNum(obj,data) {
    data.forEach(res => {
      if (res.type === 3) {
        obj[res.code] = res.num;
      } else {
        this.queryAllNum(obj, res.sons);
      }
    });
    return obj;
  }
  static queryShopSelectedGoodsCode(arr, data) {
    //店铺中全部商品
    data.forEach(res => {
      if (res.type === 3 && !isdisabled(res.skuStatus)) {
        if (res.selected) {
          arr.push(res.code);
        }
      } else {
        this.queryShopSelectedGoodsCode(arr, res.sons);
      }
    });
    return arr;
  }
  static queryShopAllGoodsCode(arr, data) {
    //店铺中全部商品
    data.forEach(res => {
      if (res.type === 3 && !isdisabled(res.skuStatus)) {
        arr.push(res.code);
      } else {
        this.queryShopAllGoodsCode(arr, res.sons);
      }
    });
    return arr;
  }
}

